import $ from "jquery";
import { useCallback, useState } from "react";
import { useHandleSelect } from "./useHandleSelect.js";
import { useStores } from "../../store/rootStore.js";
function useAppTreeDetails() {
    const { treeStore } = useStores();
    const { handleSelect } = useHandleSelect();
    const [metaBoxId, setMetaBoxId] = useState(false);
    const handleReload = useCallback(()=>{
        handleSelect();
    }, [
        handleSelect
    ]);
    const handleDetails = useCallback((action, status, response)=>{
        const selectedNumericId = Number(treeStore.selectedId);
        const nextMetaBoxId = action ? action === "usersettings" ? action : Number.isFinite(selectedNumericId) && selectedNumericId > 0 ? treeStore.selectedId : false : false;
        setMetaBoxId(nextMetaBoxId);
        if (status === true && response) {
            const { reload, hardReloadIfBodyHasClass } = response;
            if (reload) {
                handleReload();
            } else if (hardReloadIfBodyHasClass && $("body").hasClass(hardReloadIfBodyHasClass)) {
                window.location.reload();
            }
        }
    }, [
        treeStore,
        handleReload
    ]);
    return {
        metaBoxId,
        setMetaBoxId,
        handleDetails
    };
}
export { useAppTreeDetails };
